'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.daysFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/daysFromNow.js
// module id = 667
// module chunks = 0